module.exports = __webpack_public_path__ + "img/jan.8e4e722d.jpg";